import { ButtonUnstyled } from '@sketch/components'
import styled from 'styled-components'

import { ReactComponent as Arrow } from '@sketch/icons/arrow-circle-right-14-svg'

export const ArrowIcon = styled(Arrow)`
  width: 14px;
  height: 14px;
  color: ${({ theme }) => theme.colors.foreground.secondary.A};
`

export const ArtboardHeader = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: auto;
  padding: 0 0 6px 0; /* stylelint-disable-line scales/space */
  transform: translateY(-100%);
  display: flex;
  pointer-events: none;
  align-items: center;
`

export const ArtboardName = styled.span`
  position: relative;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  user-select: none;
  pointer-events: auto;
  color: ${({ theme }) => theme.colors.foreground.secondary.C};
`

export const ArtboardCTA = styled(ButtonUnstyled)`
  position: relative;
  white-space: nowrap;
  margin-right: 0;
  margin-left: auto;
  align-items: center;
  pointer-events: auto;
  display: flex;
  line-height: 1.4;
`

export const ArtboardCTAText = styled.span`
  color: ${({ theme }) => theme.colors.foreground.secondary.D};
`

export const ArrowIconWrapper = styled.span`
  position: relative;
  width: 14px;
  height: 14px;
  margin-left: 4px;
`

export const Artboard = styled.div`
  position: absolute;
  box-sizing: border-box;
  cursor: pointer;

  /* Just some default font styles */
  font-size: 0.75rem;
  font-style: normal;
  font-family: sans-serif;

  ${ArtboardCTA} {
    display: none;
  }

  &:hover {
    box-shadow: 0 0 0 2px ${({ theme }) => theme.colors.sketch.A};
  }

  &[aria-selected='true'] {
    box-shadow: 0 0 0 4px ${({ theme }) => theme.colors.sketch.A};

    ${ArtboardCTA} {
      display: flex;
    }
  }

  [data-canvas-zooming='true'] > & {
    display: none;
  }
`
